<template>
  <b-card>
    <template #header>
      <div class="d-flex align-items-center w-100">
        <h4 class="mb-0">Upload de Arquivo</h4>
        <div class="d-flex justify-content-end flex-grow-1">
          <b-button
            variant="light"
            size="sm"
            v-b-tooltip.hover="'Excluir o último arquivo enviado'"
            @click="confirmDelete"
          >
            <i class="fas fa-trash text-dark"></i>
          </b-button>
        </div>
      </div>
    </template>
    <b-form-group>
      <div class="d-flex align-items-center">
        <b-form-input
          :value="file ? file.name : ''"
          placeholder="Selecione o arquivo..."
          readonly
          class="flex-grow-1 rounded-right-0"
          @click="$refs.fileInput.click()"
        />

        <b-button variant="primary" class="rounded-left-0" @click="emitFile">
          Enviar
        </b-button>

        <input
          type="file"
          ref="fileInput"
          style="display: none"
          accept=".xls,.xlsx,.xlsm"
          @change="onFileChange"
        />
      </div>
    </b-form-group>
  </b-card>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BFormInput,
  BButton,
  VBTooltip,
} from "bootstrap-vue";

export default {
  components: {
    BCard,
    BFormGroup,
    BFormInput,
    BButton,
    VBTooltip,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      file: null,
    };
  },
  methods: {
    onFileChange(e) {
      const selectedFile = e.target.files[0];

      if (!selectedFile) return;

      const allowedExtensions = ["xls", "xlsx", "xlsm"];
      const fileExtension = selectedFile.name.split(".").pop().toLowerCase();

      if (!allowedExtensions.includes(fileExtension)) {
        this.$bvToast.toast(
          `Formato inválido! Só é permitido Excel (.xls, .xlsx, .xlsm).`,
          {
            title: "Erro",
            variant: "danger",
            solid: true,
            toaster: "b-toaster-top-right",
            autoHideDelay: 4000,
          }
        );

        e.target.value = "";
        this.file = null;
        return;
      }

      this.file = selectedFile;
    },
    async confirmDelete() {
      const confirmed = await this.$bvModal.msgBoxConfirm(
        "Tem certeza que deseja excluir o último arquivo enviado?",
        {
          title: "Confirmação",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Sim",
          cancelTitle: "Cancelar",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        }
      );

      if (confirmed) {
        this.removeFile();
      }
    },

    removeFile() {
      this.$emit("remove-file",);
      this.file = null;
      this.$refs.fileInput.value = "";
    },

    emitFile() {
      if (!this.file) return;
      this.$emit("file-uploaded", this.file);
      this.file = null;
      this.$refs.fileInput.value = "";
    },
  },
};
</script>